import React from 'react';
import { getContentDetail } from '../common';
import { CheckCircle, Comment, EmojiEvents, Share, Star } from '@mui/icons-material';
import theme from '@/constants/theme';

// components
import { Video } from './Video';
import { Audio } from './Audio';
import { Image } from './Image';
import { Reading } from './Reading';
import Quiz from './Quiz';

// styles
import { styles } from './styles';
import { formatContentDuration } from '@/utils/formatContentDuration';
import { Route } from '@/services/routes/route.vm';
import ActionButton from './ActionButton';
import useContentInteractionWatcher from './useContentInteractionWatcher';
import { Content } from '@/services/contents/content.vm';
import ContentDetailPlaceholder from './placeholder';

interface Props {
  routeId?: string;
  content: Content;
  userRouteProgressId?: Route['userRouteProgressId'];
  isStageContent?: boolean;
  loading?: boolean;
}

const ContentDetail: React.FC<Props> = ({ content, userRouteProgressId, isStageContent, loading,routeId }) => {
  const contentTypeData = getContentDetail(content.type);
  useContentInteractionWatcher({ content, userRouteProgressId, routeId });

  if (loading) return (<ContentDetailPlaceholder />);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.indicatorContainer}>
          <div style={styles.typeIndicator}>
            <contentTypeData.Icon />
            <p>
              {contentTypeData.title} • {formatContentDuration(content.duration ?? 60)}
            </p>
            {content.completed ? (
              <CheckCircle sx={{ color: theme.colors.success }} />
            ) : (
              <div style={styles.pointsContainer}>
                <p style={styles.pointsIndicator}>+ {content.points}</p>
                <EmojiEvents />
              </div>
            )}
          </div>
          <div style={styles.actionsContainer}>
            <button style={styles.actionButton}>
              <Star fontSize="small" />
            </button>
            <button style={styles.actionButton}>
              <Comment fontSize="small" />
            </button>
            <button style={styles.actionButton}>
              <Share fontSize="small" />
            </button>
          </div>
        </div>
        <div style={styles.contentSlot}>
          {/* Replacesable component */}
          {content.type === 'AUDIO' && <Audio src={content.src} subtitles={content.subtitles} />}
          {content.type === 'VIDEO' && <Video src={content.src} />}
          {content.type === 'READING' && <Reading content={content.content} />}
          {content.type === 'IMAGE' && <Image content={content.content} src={content.src} />}
          {content.type === 'QUIZ' && (
            <Quiz
              contentId={content.id}
              routeId={routeId}
              completed={content.completed}
              quizData={content.quizData}
              quizResponses={content.quizResponses}
              contentInteractionId={content.contentInteractionId}
            />
          )}
        </div>
      </div>
      <ActionButton
        contentId={content.id}
        routeId={routeId}
        completed={content.completed}
        contentType={content.type}
      />
    </div>
  );
};

export default ContentDetail;
